import React from 'react';
import { Monitor } from 'lucide-react';

export default function MinimumWidthOverlay() {
  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-surface border border-gray-700 rounded-lg p-6 text-center space-y-4">
        {/* Icon */}
        <div className="flex justify-center mb-4">
          <div className="relative">
            <Monitor className="h-12 w-12 text-primary"/>
            <div className="absolute -bottom-1 -right-1 bg-orange-500 rounded-full p-1">
              <svg className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.082 16.5c-.77.833.192 2.5 1.732 2.5z"/>
              </svg>
            </div>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-xl font-semibold text-foreground">
          Window Too Narrow
        </h2>

        {/* Description */}
        <div className="space-y-3 text-muted-foreground">
          <p className="text-sm">
            This video chat application requires a minimum width of 1024px for optimal experience.
          </p>
          <p className="text-xs">
            Please expand your browser window or use a larger screen to access all features.
          </p>
        </div>

        {/* Instructions */}
        <div className="bg-muted/30 rounded-lg p-3 space-y-2">
          <h3 className="font-medium text-foreground text-sm">Quick solutions:</h3>
          <ul className="text-xs text-muted-foreground space-y-1">
            <li>• Maximize your browser window</li>
            <li>• Use fullscreen mode (F11)</li>
            <li>• Zoom out in your browser (Ctrl + -)</li>
            <li>• Use a larger monitor or screen</li>
          </ul>
        </div>

        {/* Current width indicator */}
        <div className="text-xs text-muted-foreground pt-2 border-t border-gray-700">
          Current width: {window.innerWidth}px | Required: 800px minimum
        </div>
      </div>
    </div>
  );
}